import React from 'react';
import PropTypes from "prop-types";
import {useFormik} from "formik";
import {startOfDay} from "date-fns";

import {ResponsiveDialog} from "../../../../../components/ResponsiveDialog";
import periodValidationSchema from "./validator";
import {DateFormatter} from "../../../../../services/date";
import {isValidDateObject} from "../../../../../services/date/validators";

import {DatePicker} from "@mui/x-date-pickers";
import Grid from "@mui/material/Grid";


const FormEditPeriod = (props) => {
    const {booking, isLoading, onSubmit, onClose} = props;

    const formik = useFormik({
        initialValues: {
            arrival: booking.getArrival(),
            departure: booking.getDeparture(),
        },
        validationSchema: periodValidationSchema,
        onSubmit: values => {
            const payload = {
                arrival: DateFormatter.onlyDateISOString(values.arrival, null),
                departure: DateFormatter.onlyDateISOString(values.departure, null),
            }
            onSubmit(payload);
        }
    });

    const submitIsEnabled = !Object.keys(formik.errors).some(x => formik.touched[x]);

    return (
        <ResponsiveDialog title={"Modifica periodo"}
                          isOpen={true}
                          maxWidth="md"
                          scroll="paper"
                          isLoading={isLoading}
                          showApply={true}
                          applyLabel="Salva"
                          enableApply={submitIsEnabled}
                          onApply={formik.handleSubmit}
                          closeLabel="Cancella"
                          onClose={onClose}>

            <Grid container spacing={3} sx={{pt: 1}}>
                <Grid item xs={12} md={6}>
                    <DatePicker value={formik.values.arrival}
                                onChange={date => formik.setFieldValue("arrival", startOfDay(date))}
                                label="Data arrivo"
                                closeOnSelect
                                disableHighlightToday
                                showDaysOutsideCurrentMonth
                                slotProps={{
                                    textField: {
                                        fullWidth: true,
                                        required: true,
                                        error: Boolean(formik.touched.arrival) && Boolean(formik.errors.arrival),
                                        helperText: formik.touched.arrival && formik.errors.arrival,
                                    }
                                }}
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <DatePicker value={formik.values.departure}
                                onChange={date => formik.setFieldValue("departure", startOfDay(date))}
                                minDate={formik.values.arrival}
                                defaultCalendarMonth={isValidDateObject(formik.values.arrival) ? formik.values.arrival : undefined}
                                label="Data partenza"
                                closeOnSelect
                                disableHighlightToday
                                showDaysOutsideCurrentMonth
                                slotProps={{
                                    textField: {
                                        fullWidth: true,
                                        required: true,
                                        error: Boolean(formik.touched.departure) && Boolean(formik.errors.departure),
                                        helperText: formik.touched.departure && formik.errors.departure,
                                    }
                                }}/>
                </Grid>
            </Grid>
        </ResponsiveDialog>
    );
};

FormEditPeriod.propTypes = {
    booking: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
}

export default FormEditPeriod;